module.exports = __webpack_public_path__ + "img/aej1n-66wvl.020.475050a6.png";